import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';

import EmployeesList from '../components/list';

class EmployeesRowContainer extends Component {
  render = () => (
    <EmployeesList.Row
      handleToggle={this.props.handleToggle}
      company={this.props.company}
      subcompany={this.props.subcompany}
      employee={this.props.employee}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(EmployeesRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/containers/EmployeesRowContainer.js